import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Drawer, Col, Row } from 'antd';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import DrawerMenu from './drawer';

export default function Header() {
  const [showDrawer, setShowDrawer] = useState(false);

  const openDrawer = () => {
    setShowDrawer(true);
  };
  const closeDrawer = () => {
    setShowDrawer(false);
  };

  return (
    <Row id="header" className="header" align="middle">
      <Col span={5}>
        <Link href="/">
          <a onClick={closeDrawer}>
            <Image
              src={require('../../public/images/首页.svg').default}
              alt="Logo"
              layout="responsive"
              priority
            />
          </a>
        </Link>
      </Col>

      <Col span={12} offset={2} className="header_title">
        <Link href="/">
          <a className="text-white" onClick={closeDrawer}>
            讯梦国际
          </a>
        </Link>
      </Col>

      <Col span={5} className="text-right">
        {!showDrawer ? (
          <div className="button text-white" onClick={openDrawer}>
            <MenuOutlined />
          </div>
        ) : (
          <div className="button text-white" onClick={closeDrawer}>
            <CloseOutlined />
          </div>
        )}
        <Drawer
          placement="right"
          closable={false}
          onClose={closeDrawer}
          visible={showDrawer}
        >
          <DrawerMenu closeDrawer={closeDrawer} />
        </Drawer>
      </Col>
    </Row>
  );
}
